import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "width", "height", "poster"]

import { reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: { default: '' },
    size: { default: 100 },
    height: { default: 70 },
    poster: { default: 'https://visionhealthmed.com/static/img/video.png' }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const list = reactive([]);

const compatible = () => {
    list.length = 0;

    if (!props.value) return;

    if (props.value.indexOf('[') !== -1 && props.value.indexOf(']') !== -1) {
        list.push(...JSON.parse(props.value));
        return;
    }

    list.push(...props.value.split(','));
};

compatible();

__expose({
    compatible
});


return (_ctx: any,_cache: any) => {
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createBlock(_component_a_image_preview_group, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (url, index) => {
        return (_openBlock(), _createElementBlock("video", {
          key: index,
          controls: "",
          src: url,
          width: props.size,
          height: props.height,
          poster: props.poster
        }, null, 8, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }))
}
}

})